import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Missing Supabase credentials in .env file");
}

// Global store to hold the Clerk getToken reference dynamically
export const clerkAuthStore = {
  getToken: null
};

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  accessToken: async () => {
    console.log('[SupabaseClient] Resolving dynamic accessToken...');
    if (clerkAuthStore.getToken) {
      try {
        // Fetch token dynamically from Clerk
        const token = await clerkAuthStore.getToken({ template: 'supabase' });
        console.log('[SupabaseClient] Dynamic token fetched:', token ? token.substring(0, 20) + '...' : 'null');
        return token || null;
      } catch (err) {
        console.error('[SupabaseClient] Dynamic accessToken error:', err);
      }
    } else {
      console.warn('[SupabaseClient] clerkAuthStore.getToken is not set!');
    }
    return null;
  }
});
